import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { TrainingsView } from "./trainings-view";
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";

import "./trainings.scss";

export const TrainingsControler = (props) => {
	const [results, setResults] = useState([]);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/item?param=training&id=0&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, []);

	return (
		<>
			<Helmet>
				<title>Training Courses | SmarterChains</title>
				<meta name="description" content="Training Courses" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/trainings">Training Courses</BreadcrumbsItem>
			<TrainingsView trainingData={results} {...props} />
			
		</>
	);
};
